import { useHasPermission } from '../hooks/useHasPermission';
import { InlineEdit } from './inline-edit';
import { Input } from './input';

type InlineTextEditProps = {
  permission: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  displayValue?: (value: string) => string;
  small?: boolean;
  disabled?: boolean;
  className?: string;
  type?: 'text' | 'number' | 'email' | 'password' | 'search' | 'tel' | 'url';
  inputMode?: 'numeric' | 'text' | 'decimal' | 'email' | 'search' | 'tel' | 'url';
  onBlur?: (value: string) => void;
  [key: string]: unknown;
};

export function InlineTextEdit({
  permission,
  value,
  onChange,
  placeholder,
  displayValue,
  small = false,
  disabled = false,
  className,
  type = 'text',
  inputMode,
  onBlur,
  ...inputProps
}: InlineTextEditProps) {
  const canEdit = useHasPermission(permission);

  const handleDisplay = (val: string) => {
    if (displayValue) {
      return displayValue(val);
    }
    return val || placeholder || '';
  };

  return (
    <InlineEdit<string>
      readOnly={!canEdit}
      value={value}
      onChange={onChange}
      renderDisplay={handleDisplay}
      renderEditor={(val, handleChange, onBlurCommit) => (
        <Input
          {...(inputProps as Record<string, unknown>)}
          name="inline-text-edit"
          value={val}
          onChange={(e) => handleChange(e.target.value)}
          onBlur={(e) => {
            onBlurCommit(e.target.value);
          }}
          placeholder={placeholder}
          type={type}
          inputMode={inputMode}
          small={small}
          variant={small ? 'inline' : 'default'}
          disabled={disabled}
        />
      )}
      onBlur={onBlur}
      small={small}
      className={className}
    />
  );
}
